module.exports = __webpack_public_path__ + "static/brand-heilai-ba60cd1c21371b8df863056b57735d61.png";